<template>
  <!-- MONEY TRANSFER -->
  <v-modal
    :name="name"
    title="Contratar mais horas"
    :show="show"
    @onHide="onHide"
    @onShow="onShow"
    :size="1"
  >
    <v-inner>
      <v-input type="integer" min="1" v-model="contract_new_hours_value"
        >Informe quantas horas deseja adicionar ao contrato do
        Vibbrante</v-input
      >
      <v-alert>
        Essas horas serão adicionadas automaticamente ao contrato atual como
        adendo, seguindo o mesmo padrão de aquisição de créditos para
        liberá-las.
      </v-alert>
      <v-button class="block primary" @click="addHoursToContract()"
        >Contratar</v-button
      >
    </v-inner>
  </v-modal>
</template>

<script>
import clientApi from '@/api/client';

export default {
  props: {
    show: {
      default: false,
    },
    title: {
      default: '',
    },
    name: {
      default: 'modal',
    },
    size: {
      default: 3,
    },
    profile: {
      default: 'vibbrant',
    },
    data: {},
  },
  components: {},
  methods: {
    hide() {
      this.onHide();
      this.show = false;
    },
    onHide() {
      this.refresh = false;
      this.$emit('onHide');

      // OK vars
      this.feedback_ok = false;
      this.bug_ok = false;
      this.money_transfer_ok = false;
      this.action_success = false;
      this.finalized_ok = false;
    },
    addHoursToContract() {
      clientApi
        .clientCreateContractAdditive(
          this.data.contract.id,
          this.contract_new_hours_value
        )
        .then(response => {
          if (response.status === 200) {
            clientApi
              .clientGetContract(this.$route.params.id)
              .then(response => {
                if (response.status === 200) {
                  this.$store.dispatch(
                    'loadClientCurrentContract',
                    response.data
                  );
                  this.$emit('onRequestCredit', this.contract_new_hours_value);
                  this.hide();
                }
              })
              .catch(e => {
                this.$notify(e, 'error');
              });
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/parts/modals/contract-new-hours.vue